import Button from "@mui/material/Button";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

const OKButton = (props) => {
  return (
    <Button
      type="submit"
      variant="contained"
      startIcon={<CheckOutlinedIcon />}
      color="primary"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      OK
    </Button>
  );
};

export default OKButton
